import { FiltrosPreDefinidos } from "../..";

export const filtrosPreDefinidos: Array<FiltrosPreDefinidos> = [
    {
        nome: "Defensivos",
        filtros: {
            origem: {
                id: 34,
                nome: "Coopervass CDA"
            },
            departamentos: [
                { id: 37, nome: "ADJUVANTES" },
                { id: 19, nome: "ALMOXARIFADO AGP E PATIO" },
                { id: 18, nome: "ALMOXARIFADO LATICINIO" },
                { id: 27, nome: "ALMOXARIFADO USO/CONSUMO" },
                { id: 420, nome: "AMONIA QUATERNARIA" },
                { id: 800, nome: "ASSISTENCIA TECNICA" },
                { id: 145, nome: "BEBEDOUROS" },
                { id: 925, nome: "BIOLOGICOS" },
                { id: 20, nome: "CAFE" },
                { id: 34, nome: "CAFETERIA" },
                { id: 36, nome: "CLASSE A" },
                { id: 29, nome: "DEFENSIVOS" },
                { id: 153, nome: "FERTILIZANTE FOLIAR" },
                { id: 999, nome: "IMOBILIZADOS" },
                { id: 52, nome: "INDEFINIDO" },
                { id: 525, nome: "INOCULANTES" },
                { id: 35, nome: "LATICINIO" },
                { id: 23, nome: "LATICINIO PRODUTOS ACABADOS" },
                { id: 100, nome: "MATERIAL CONSUMO ADM" },
                { id: 17, nome: "MORTO LATICINIO" },
                { id: 26, nome: "MUDAS" },
                { id: 7, nome: "NAO UTILIZAR - ANTIGO PECAS" },
                { id: 154, nome: "OFICINA DE PECAS MANUTENCOES" },
                { id: 59, nome: "OLEO MINERAL" },
                { id: 58, nome: "PRODUTOS BIOLOGICOS" },
                { id: 24, nome: "RACOES PRODUZIDA POR TERCEIROS" },
                { id: 620, nome: "RAFER" },
                { id: 580, nome: "REALCE DECORACOES" },
                { id: 431, nome: "SEMENTES SOJA" },
                { id: 678, nome: "SILOS" },
                { id: 914, nome: "SILOS" },
                { id: 670, nome: "TRATOR" },
                { id: 99, nome: "UNIFORMES" }
            ]
        }
    },
    {
        nome: "Varejo",
        filtros: {
            origem: {
                id: 34,
                nome: "Coopervass CDA"
            },
            departamentos: [
                { id: 25, nome: "ACQUALIMP" },
                { id: 19, nome: "ALMOXARIFADO AGP E PATIO" },
                { id: 18, nome: "ALMOXARIFADO LATICINIO" },
                { id: 27, nome: "ALMOXARIFADO USO/CONSUMO" },
                { id: 420, nome: "AMONIA QUATERNARIA" },
                { id: 46, nome: "ARAME / PREGO" },
                { id: 800, nome: "ASSISTENCIA TECNICA" },
                { id: 145, nome: "BEBEDOUROS" },
                { id: 925, nome: "BIOLOGICOS" },
                { id: 151, nome: "BOTAS" },
                { id: 152, nome: "BOTINAS" },
                { id: 20, nome: "CAFE" },
                { id: 34, nome: "CAFETERIA" },
                { id: 15, nome: "CARRINHO" },
                { id: 36, nome: "CLASSE A" },
                { id: 53, nome: "CONEXOES DIVERSAS" },
                { id: 13, nome: "CORDA" },
                { id: 8, nome: "CORREIAS" },
                { id: 14, nome: "CORRENTES" },
                { id: 44, nome: "FERRAMENTAS" },
                { id: 42, nome: "FILTROS AUTOMOTIVOS" },
                { id: 11, nome: "GERAL" },
                { id: 999, nome: "IMOBILIZADOS" },
                { id: 52, nome: "INDEFINIDO" },
                { id: 525, nome: "INOCULANTES" },
                { id: 6, nome: "INSETICIDAS" },
                { id: 35, nome: "LATICINIO" },
                { id: 23, nome: "LATICINIO PRODUTOS ACABADOS" },
                { id: 2, nome: "LOJA DE FRIOS" },
                { id: 31, nome: "LONAS DIVERSAS" },
                { id: 45, nome: "LUBRIFICANTES" },
                { id: 54, nome: "MANGUEIRAS" },
                { id: 16, nome: "MAQUINAS" },
                { id: 100, nome: "MATERIAL CONSUMO ADM" },
                { id: 43, nome: "MATERIAL DE COLHEITA" },
                { id: 12, nome: "MATERIAL ELETRICO" },
                { id: 17, nome: "MORTO LATICINIO" },
                { id: 26, nome: "MUDAS" },
                { id: 7, nome: "NAO UTILIZAR - ANTIGO PECAS" },
                { id: 154, nome: "OFICINA DE PECAS MANUTENCOES" },
                { id: 59, nome: "OLEO MINERAL" },
                { id: 101, nome: "ORDENHA" },
                { id: 51, nome: "PARAF/PORCA/ARRUELA" },
                { id: 3, nome: "PECAS AGRICOLAS" },
                { id: 47, nome: "PECAS PULVERIZADOR" },
                { id: 928, nome: "PNEU" },
                { id: 33, nome: "PRODUTOS VETERINARIOS" },
                { id: 28, nome: "RACOES CAO / DIVERSAS" },
                { id: 24, nome: "RACOES PRODUZIDA POR TERCEIROS" },
                { id: 620, nome: "RAFER" },
                { id: 580, nome: "REALCE DECORACOES" },
                { id: 951, nome: "RODOS" },
                { id: 102, nome: "SELARIA" },
                { id: 21, nome: "SEMENTE DE SOJA" },
                { id: 22, nome: "SEMENTES DIVERSAS" },
                { id: 50, nome: "SEMENTES MILHO" },
                { id: 431, nome: "SEMENTES SOJA" },
                { id: 678, nome: "SILOS" },
                { id: 914, nome: "SILOS" },
                { id: 30, nome: "SUPLEMENTO ANIMAL" },
                { id: 670, nome: "TRATOR" },
                { id: 99, nome: "UNIFORMES" }
            ]
        }
    },
    {
        nome: "Peças",
        filtros: {
            origem: {
                id: 1,
                nome: "Coopervass MTZ"
            },
            departamentos: [
                { id: 25, nome: "ACQUALIMP" },
                { id: 19, nome: "ALMOXARIFADO AGP E PATIO" },
                { id: 18, nome: "ALMOXARIFADO LATICINIO" },
                { id: 27, nome: "ALMOXARIFADO USO/CONSUMO" },
                { id: 420, nome: "AMONIA QUATERNARIA" },
                { id: 800, nome: "ASSISTENCIA TECNICA" },
                { id: 145, nome: "BEBEDOUROS" },
                { id: 925, nome: "BIOLOGICOS" },
                { id: 20, nome: "CAFE" },
                { id: 34, nome: "CAFETERIA" },
                { id: 36, nome: "CLASSE A" },
                { id: 14, nome: "CORRENTES" },
                { id: 4, nome: "ELETRODO" },
                { id: 42, nome: "FILTROS AUTOMOTIVOS" },
                { id: 999, nome: "IMOBILIZADOS" },
                { id: 52, nome: "INDEFINIDO" },
                { id: 525, nome: "INOCULANTES" },
                { id: 35, nome: "LATICINIO" },
                { id: 23, nome: "LATICINIO PRODUTOS ACABADOS" },
                { id: 2, nome: "LOJA DE FRIOS" },
                { id: 100, nome: "MATERIAL CONSUMO ADM" },
                { id: 17, nome: "MORTO LATICINIO" },
                { id: 26, nome: "MUDAS" },
                { id: 7, nome: "NAO UTILIZAR - ANTIGO PECAS" },
                { id: 154, nome: "OFICINA DE PECAS MANUTENCOES" },
                { id: 59, nome: "OLEO MINERAL" },
                { id: 3, nome: "PECAS AGRICOLAS" },
                { id: 47, nome: "PECAS PULVERIZADOR" },
                { id: 928, nome: "PNEU" },
                { id: 33, nome: "PRODUTOS VETERINARIOS" },
                { id: 24, nome: "RACOES PRODUZIDA POR TERCEIROS" },
                { id: 620, nome: "RAFER" },
                { id: 580, nome: "REALCE DECORACOES" },
                { id: 951, nome: "RODOS" },
                { id: 41, nome: "ROLAMENTOS" },
                { id: 21, nome: "SEMENTE DE SOJA" },
                { id: 431, nome: "SEMENTES SOJA" },
                { id: 678, nome: "SILOS" },
                { id: 914, nome: "SILOS" },
                { id: 670, nome: "TRATOR" },
                { id: 99, nome: "UNIFORMES" }
            ]
        }
    }
]
